import React from "react"; 
import SignInForm from "../../mycomp/Authentication/SignInForm";

const SignIn = () => {
  return (
    <>
      <SignInForm />
    </>
  );
};

export default SignIn;
